"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _get_cat_tags = require("@/api/get_cat_tags");

var _cat_tags = require("@/api/cat_tags");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {
      editCatTagsForm: {
        tags: null
      },
      inputVisible: false,
      inputValue: '',
      activeName: 'first'
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.listLoading = true;
      (0, _get_cat_tags.getCatTags)().then(function (response) {
        var catTagsList = response.data;
        _this.editCatTagsForm.tags = catTagsList;
        _this.listLoading = false;
      });
    },
    handleClose: function handleClose(tag) {
      var _this2 = this;

      (0, _cat_tags.destroy)(tag.id).then(function (data) {
        _this2.$message({
          message: data.msg,
          type: 'success'
        });

        _this2.editCatTagsForm.tags.splice(_this2.editCatTagsForm.tags.indexOf(tag), 1);

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    showInput: function showInput() {
      var _this3 = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this3.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var _this4 = this;

      var inputValue = this.inputValue;

      if (inputValue) {
        this.$store.dispatch('cat_tags/edit', {
          tag: inputValue
        }).then(function (data) {
          console.log(data);

          _this4.$message({
            message: data.msg,
            type: 'success'
          });

          _this4.editCatTagsForm.tags.push(data.data);

          _this4.loading = false;
        }).catch(function () {
          _this4.loading = false;
        });
      }

      this.inputVisible = false;
      this.inputValue = '';
    },
    handleLink: function handleLink(id) {
      if (id !== undefined) {
        this.$router.push("/cat-base/details/".concat(id));
      } else {
        this.$router.push("/cat-base/details");
      }
    },
    handleClick: function handleClick(tab, event) {// console.log(tab, event)
    }
  }
};
exports.default = _default;